export function classNames (names: Record<string, boolean>): string {
  return Object.keys(names).filter(k => names[k]).join(' ')
}
